'use client';

import { useEffect, useState } from 'react';
import {
  getAppCheckHealth,
  subscribeAppCheckHealth,
  type AppCheckHealth,
} from '../firebase/appCheck';

/**
 * Subscribe to the Firebase App Check health signal.
 *
 * Returns the current attestation health (`'unknown' | 'healthy' | 'degraded'`)
 * and re-renders whenever it transitions. Useful for surfacing an attestation
 * outage in the UI (e.g. a degraded-service banner) without coupling the
 * component to the App Check module's mutable state.
 *
 * @returns The current {@link AppCheckHealth}.
 */
export function useAppCheckHealth(): AppCheckHealth {
  const [health, setHealth] = useState<AppCheckHealth>(() => getAppCheckHealth());

  useEffect(() => {
    // Re-seed in case health changed between the initial render and effect run.
    setHealth(getAppCheckHealth());
    const unsubscribe = subscribeAppCheckHealth(setHealth);
    return unsubscribe;
  }, []);

  return health;
}
